"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var config_1 = require("../config");
var next_1 = require("@alifd/next");
var react_2 = require("react");
var contextManage_1 = require("../contextManage");
var task_1 = require("@alife/task");
var esign_image_1 = require("../static/images/esign-image");
var sign_image_1 = require("../static/images/sign-image");
var Esign = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    react_2.useEffect(function () {
        if (context.progress === config_1.PROCESS.pending) {
            createFaceTask();
        }
        else if (context.progress === config_1.PROCESS.success) {
            // 执行签名回掉函数
            context.clear();
            context.success(context.taskResult);
        }
        else if (context.progress === config_1.PROCESS.failed || context.progress === config_1.PROCESS.aborted) {
            next_1.Message.notice('用户已取消');
            context.closeDialog();
        }
    }, [context.progress]);
    var createFaceTask = function () { return __awaiter(_this, void 0, void 0, function () {
        var deviceStatus, data, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    deviceStatus = task_1.Util.getDeviceStatus();
                    if (!deviceStatus.pad) {
                        //没有设备的情况下，唤起设备管理对话框
                        if (self !== top) {
                            data = {
                                type: 'deviceConnect',
                                data: 'pad',
                            };
                            window.top.postMessage(data, '*');
                            //关闭弹窗
                            context.closeDialog();
                            return [2 /*return*/];
                        }
                    }
                    return [4 /*yield*/, context.createTask(config_1.TASKTYPE.esign, JSON.stringify({
                            url: props.padUrl,
                        }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    if (context.progress === config_1.PROCESS.pending) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status", key: 1 }, "\u4EFB\u52A1\u53D1\u9001\u4E2D\uFF0C\u8BF7\u7A0D\u540E"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: esign_image_1.default })),
            React.createElement("div", { className: "center" },
                React.createElement(next_1.Button, { type: "primary", onClick: function () { context.closeDialog(); } }, "\u53D6\u6D88"))));
    }
    else if (context.progress === config_1.PROCESS.processing) {
        // 签名任务
        return (React.createElement("div", null,
            React.createElement("div", { className: "status", key: 1 }, "\u7B7E\u7AE0\u4E2D\uFF0C\u8BF7\u7A0D\u540E"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: sign_image_1.default })),
            React.createElement("div", { className: "center" },
                React.createElement(next_1.Button, { type: "primary", onClick: function () { context.closeDialog(); } }, "\u53D6\u6D88"))));
    }
    else if (context.progress === config_1.PROCESS.success) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status2", key: 1 }, "\u7B7E\u5B57\u63D0\u4EA4\u6210\u529F"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: sign_image_1.default }))));
    }
    else if (context.progress === config_1.PROCESS.aborted) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "status2", key: 1 }, "\u7528\u6237\u53D6\u6D88"),
            React.createElement("div", { className: "payload", key: 2 },
                React.createElement("img", { src: sign_image_1.default }))));
    }
    return React.createElement("div", null);
};
exports.default = Esign;
